// @flow
import React from 'react';
import styled from 'styled-components';
import * as Buttons from 'styles/Buttons';
import * as Layout from 'styles/Layout';
import _ from 'lodash';

const Container = styled(Layout.FlexRow)`
  width: 100%;
  margin-bottom: 20px;
`;
const Spacer = styled.div`
  flex-basis: 0;
  flex-grow: 1;
`;
const OptionButton = styled(Buttons.DefaultButton)`
  width: 140px;
  border-radius: 2px;
  color: #4a4a4a;
  background-color: #ffffff;
  border: 1px solid #cdcdcd;
  box-shadow: none;
  &.selected {
    color: ${props => props.selectedColor};
    border: 1px solid ${props => props.selectedColor};
    font-weight: bold;
  }
`;
const CheckBoxInput = styled.input`
  display: none;
`;

type typeOfInput = string | boolean | typeof undefined;

type PropsType = {
  name: string,
  value: string | boolean,
  onValueChange: (typeOfInput, string) => void,
  color?: string
};

type StateType = {
  inputValue: typeOfInput
};

export default class YesNoOptionComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    color: '#278C7E'
  };

  state = {
    inputValue: _.isNil(this.props.value) ? '' : this.props.value
  };

  setFieldValue = (inputValue: boolean): void => {
    this.setState({ inputValue }, () => {
      const { name } = this.props;
      this.props.onValueChange(inputValue, name);
    });
  };

  handleChange = (): void => {
    const { name } = this.props;
    this.props.onValueChange(this.state.inputValue, name);
  };

  render() {
    const { inputValue } = this.state;
    const { name, color } = this.props;

    return (
      <Container>
        <OptionButton
          onClick={() => this.setFieldValue(true)}
          type="button"
          className={inputValue === true ? 'selected' : ''}
          selectedColor={color}
        >
          Si
        </OptionButton>
        <Spacer />
        <OptionButton
          onClick={() => this.setFieldValue(false)}
          type="button"
          className={inputValue === false ? 'selected' : ''}
          selectedColor={color}
        >
          No
        </OptionButton>
        <CheckBoxInput
          name={name}
          id={name}
          type="checkbox"
          value={inputValue}
          checked={inputValue}
          onChange={this.handleChange}
        />
      </Container>
    );
  }
}
